export const taxIdRegexp: RegExp = new RegExp(/^\d{10}$/);
